import { useState } from "react";
import { Menu, X } from "lucide-react";

const navStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Noto+Serif:ital,wght@0,400;0,600;1,400&display=swap');

  .nav-shell {
    position: sticky;
    top: 0;
    z-index: 100;
    background: linear-gradient(135deg, #3d0000 0%, #6b0000 40%, #8B0000 70%, #5a0000 100%);
    box-shadow: 0 4px 30px rgba(0,0,0,0.5);
  }
  .nav-shell::before {
    content: '';
    display: block;
    height: 3px;
    background: linear-gradient(90deg, transparent, #F0C040, #C9920A, #F0C040, transparent);
  }
  .nav-shell::after {
    content: '';
    display: block;
    height: 2px;
    background: linear-gradient(90deg, transparent, #a07010, #F0C040, #a07010, transparent);
  }
  .nav-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
  }
  .logo-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
  }
  .logo-icon {
    width: 42px; height: 42px;
    border-radius: 50%;
    background: radial-gradient(circle at 40% 35%, #F0C040, #C9920A 50%, #7a5500);
    display: flex; align-items: center; justify-content: center;
    font-size: 22px;
    box-shadow: 0 0 14px rgba(240,192,64,0.7);
    animation: pulseGlow 3s ease-in-out infinite;
  }
  @keyframes pulseGlow {
    0%,100% { box-shadow: 0 0 14px rgba(240,192,64,0.7); }
    50% { box-shadow: 0 0 30px rgba(240,192,64,1), 0 0 50px rgba(240,192,64,0.3); }
  }
  .logo-text {
    font-family: 'Cinzel', serif;
    font-size: 1.05rem; font-weight: 700;
    color: #F0C040; line-height: 1.25;
    text-shadow: 0 0 20px rgba(240,192,64,0.5), 1px 1px 3px rgba(0,0,0,0.8);
    letter-spacing: 0.04em;
  }
  .logo-sub {
    font-family: 'Noto Serif', serif;
    font-size: 0.65rem; color: #e0b870;
    letter-spacing: 0.12em; text-transform: uppercase; opacity: 0.85;
  }
  .nav-links { display: flex; align-items: center; gap: 0.5rem; list-style: none; }
  .nav-links li a {
    font-family: 'Cinzel', serif;
    font-size: 0.82rem; font-weight: 600;
    letter-spacing: 0.12em; color: #e8c97a;
    text-decoration: none; padding: 8px 18px;
    border-radius: 2px; position: relative;
    transition: color 0.3s; text-transform: uppercase;
  }
  .nav-links li a::after {
    content: '';
    position: absolute; bottom: 4px; left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 60%; height: 1px;
    background: #F0C040;
    transition: transform 0.3s;
  }
  .nav-links li a:hover { color: #F0C040; text-shadow: 0 0 12px rgba(240,192,64,0.7); }
  .nav-links li a:hover::after { transform: translateX(-50%) scaleX(1); }
  .nav-cta {
    font-family: 'Cinzel', serif !important;
    font-size: 0.78rem !important; font-weight: 700 !important;
    color: #4A0000 !important;
    background: linear-gradient(135deg, #F0C040, #C9920A) !important;
    padding: 9px 22px !important; border-radius: 2px !important;
    box-shadow: 0 2px 12px rgba(201,146,10,0.4) !important;
    transition: all 0.3s !important;
  }
  .nav-cta:hover {
    box-shadow: 0 4px 20px rgba(240,192,64,0.6) !important;
    transform: translateY(-1px) !important;
  }
  .nav-cta::after { display: none !important; }
  .hamburger {
    background: none; border: 1px solid rgba(201,146,10,0.5);
    border-radius: 3px; color: #F0C040; padding: 6px;
    cursor: pointer; display: none; transition: all 0.2s;
  }
  .hamburger:hover { background: rgba(201,146,10,0.15); border-color: #F0C040; }
  .mobile-menu {
    overflow: hidden; max-height: 0;
    transition: max-height 0.4s cubic-bezier(0.4,0,0.2,1);
    background: linear-gradient(180deg, #3d0000, #2a0000);
    border-top: 1px solid rgba(201,146,10,0.3);
  }
  .mobile-menu.open { max-height: 320px; }
  .mobile-menu ul { list-style: none; padding: 1rem 2rem 1.5rem; display: flex; flex-direction: column; gap: 0.25rem; }
  .mobile-menu ul li a {
    font-family: 'Cinzel', serif; font-size: 0.9rem; font-weight: 600;
    letter-spacing: 0.12em; color: #e8c97a;
    text-decoration: none; display: block; padding: 10px 0;
    border-bottom: 1px solid rgba(201,146,10,0.15);
    text-transform: uppercase; transition: color 0.2s, padding-left 0.2s;
  }
  .mobile-menu ul li:last-child a { border-bottom: none; }
  .mobile-menu ul li a:hover { color: #F0C040; padding-left: 10px; }
  @media (max-width: 768px) {
    .nav-links { display: none; }
    .hamburger { display: flex; }
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const links = [
    { label: "Home", href: "#home" },
    { label: "Poojas", href: "#poojas" },
    // { label: "Gallery", href: "#gallery" },
    // { label: "Contact", href: "#contact" },
  ];

  return (
    <>
      <style>{navStyles}</style>
      <nav className="nav-shell">
        <div className="nav-inner">
          <a href="#home" className="logo-wrap">
            <div className="logo-icon">🪔</div>
            <div>
              <div className="logo-text">Sri Ayyalanandha Siddhar</div>
              <div className="logo-sub">Jeeva Samadhi Madalayam · Vellore</div>
            </div>
          </a>
          <ul className="nav-links">
            {links.map((l) => (
              <li key={l.href}><a href={l.href}>{l.label}</a></li>
            ))}
            <li><a href="#contact" className="nav-cta">Book Pooja</a></li>
          </ul>
          <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
          <ul>
            {[...links, { label: "Book Pooja", href: "#poojas" }].map((l) => (
              <li key={l.label}><a href={l.href} onClick={() => setIsOpen(false)}>{l.label}</a></li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;